import { CalendarDays, ClipboardList, Mail, NotebookPen, Phone } from "lucide-react";
import { FaWhatsapp } from "react-icons/fa";
import { useState } from "react";

import LeadActivityModal from "./LeadActivityModal";

const activities = [
  { type: "CALL", label: "Call", description: "Log a call", icon: Phone, color: "bg-cyan-50 text-cyan-600 group-hover:bg-cyan-100" },
  { type: "FOLLOWUP", label: "Follow-up", description: "Set a reminder", icon: ClipboardList, color: "bg-blue-50 text-blue-600 group-hover:bg-blue-100" },
  { type: "NOTE", label: "Note", description: "Add context", icon: NotebookPen, color: "bg-amber-50 text-amber-600 group-hover:bg-amber-100" },
  { type: "MEETING", label: "Meeting", description: "Schedule time", icon: CalendarDays, color: "bg-cyan-50 text-cyan-600 group-hover:bg-cyan-100" },
  { type: "EMAIL", label: "Email", description: "Log an email", icon: Mail, color: "bg-rose-50 text-rose-600 group-hover:bg-rose-100" },
  { type: "WHATSAPP", label: "WhatsApp", description: "Start a chat", icon: FaWhatsapp, color: "bg-emerald-50 text-emerald-600 group-hover:bg-emerald-100" },
];

export default function ActivityStrip({ leadId, onSuccess, phone }) {
  const [selectedType, setSelectedType] = useState(null);

  const handleActivityClick = (activity) => {
    if (activity.type === "WHATSAPP") {
      if (!phone) return;

      window.open(`https://wa.me/${phone.replace(/\D/g, "")}`, "_blank", "noopener,noreferrer");
      return;
    }

    setSelectedType(activity.type);
  };

  return (
    <>
      <section aria-label="Lead actions" className="rounded-xl border border-slate-200 bg-white p-1.5 shadow-sm">
        <div className="grid grid-cols-3 gap-1 sm:grid-cols-6">
          {activities.map((activity) => {
            const Icon = activity.icon;
            const disabled = activity.type === "WHATSAPP" && !phone;

            return (
              <button
                key={activity.type}
                type="button"
                disabled={disabled}
                onClick={() => handleActivityClick(activity)}
                title={disabled ? "Add a phone number to use WhatsApp" : activity.description}
                className="group flex h-11 min-w-0 items-center justify-center gap-2 rounded-lg px-2 text-left transition hover:bg-slate-50 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-35 disabled:active:scale-100"
              >
                <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-lg transition ${activity.color}`}>
                  <Icon className="h-4 w-4" />
                </span>
                <span className="truncate text-xs font-semibold text-slate-700">{activity.label}</span>
              </button>
            );
          })}
        </div>
      </section>

      {selectedType && (
        <LeadActivityModal
          leadId={leadId}
          type={selectedType}
          phone={phone}
          onClose={() => setSelectedType(null)}
          onSuccess={() => {
            setSelectedType(null);
            onSuccess?.();
          }}
        />
      )}
    </>
  );
}
